module.exports = __webpack_public_path__ + "img/right.3dd656ac.png";